var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{attrs:{"rowSize":"lg","columns":_vm.parameterColumns,"rows":_vm.rows,"height":"100%"},on:{"changedRow":_vm.changedRow}})
}
var staticRenderFns = []

export { render, staticRenderFns }